import React, { ReactNode } from "react";
import { Card, Link } from "@heroui/react";

interface Rule {
  question: string;
  answer: string;
}

const enBaseUrl = "https://en.onepiece-cardgame.com/pdf/";
const asiaenBaseUrl = "https://asia-en.onepiece-cardgame.com/pdf/";

const rulesMap = {
  OP07: `${asiaenBaseUrl}qa_op07.pdf?20240222`,
  EB01: `${asiaenBaseUrl}qa_eb01.pdf?20240126`,
  OP06: `${enBaseUrl}qa_op06.pdf?20240222`,
  OP05: `${enBaseUrl}qa_op05.pdf?20231124`,
  OP04: `${enBaseUrl}qa_op04.pdf?20230915`,
  OP03: `${enBaseUrl}qa_op03.pdf?20230623`,
  OP02: `${enBaseUrl}qa_op02.pdf?20230609`,
  OP01: `${enBaseUrl}qa_op01.pdf?20230609`,

  ST13: `${asiaenBaseUrl}qa_st-13.pdf?202312221`,
  ST12: `${enBaseUrl}qa_st-12.pdf?20240301`,
  ST11: `${enBaseUrl}qa_st-11.pdf?20240119`,
  ST09: `${enBaseUrl}qa_st-09.pdf?20230728`,
  ST08: `${enBaseUrl}qa_st-08.pdf?20230728`,
  ST07: `${enBaseUrl}qa_st-07.pdf?20230609`,
  ST06: `${enBaseUrl}qa_st-06.pdf?20230303`,
  ST05: `${enBaseUrl}qa_st-05.pdf?20230127`,
  ST04: `${enBaseUrl}qa_st-01-st-04.pdf?20221104`,
  ST03: `${enBaseUrl}qa_st-01-st-04.pdf?20221104`,
  ST02: `${enBaseUrl}qa_st-01-st-04.pdf?20221104`,
  ST01: `${enBaseUrl}qa_st-01-st-04.pdf?20221104`,

  P: `${asiaenBaseUrl}qa_promotion-card.pdf?20231222`,
};

function getOfficialRulesLink(groupId: string): string {
  if (groupId in rulesMap) {
    return rulesMap[groupId as keyof typeof rulesMap];
  }
  return "#";
}

export function RulesQA({
  name,
  rules,
  groupId,
}: {
  name: string;
  rules: Rule[];
  groupId: string;
}): ReactNode {
  let rulesQA = [];

  for (let i of rules) {
    rulesQA.push(
      <div key={i.question} className="mb-6">
        <div className="font-extralight mb-2">{i["question"]}</div>
        <div className="font-normal text-slate-200">{i["answer"]}</div>
      </div>,
    );
  }
  return (
    <Card className="leading-loose pt-4 px-6 pb-6 dark:text-slate-300 w-full mt-4">
      <h2 className="font-normal text-xl dark:text-slate-200 mb-2">
        {groupId} {name} Rules Q&A
      </h2>
      <Link
        className="my-4"
        showAnchorIcon
        size="lg"
        href={getOfficialRulesLink(groupId)}
        color="primary"
      >
        View Official Rules
      </Link>
      {rulesQA}
    </Card>
  );
}
